<template>
  <div class="product-add" v-loading="loading">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="商品详情" name="content"></el-tab-pane>
    </el-tabs>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
      <!--基础信息-->
      <Basic v-show="activeName == 'basic'"></Basic>
      <!--服务详情-->
      <Content v-show="activeName == 'content'"></Content>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :disabled="save_loading">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import ServiceApi from '@/api/service.js';
  import Basic from './part/Basic.vue';
  import Content from './part/Content.vue';
  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    components: {
      Basic,
      Content,
    },
    data() {
      return {
        activeName: 'basic',
        id: 0,
        /*判断是编辑*/
        scene: 'edit',
        /*是否正在加载*/
        loading: true,
        /*是否正在提交保存*/
        save_loading: false,
        /*form表单数据*/
        form: {
          model: {},
          category: []
        },
        /*模型数据*/
        model: {
          name: '',
          category_id: null,
          image: [],
          content: '',
          status: 1,
          sort: null,
          hour: null,
          minute: null,
          price: null,
        },
      };
    },
    provide: function() {
      return {
        form: this.form
      };
    },
    created() {
      /*获取列表*/
      this.id = this.$route.query.id;
      this.scene = this.$route.query.scene;
      this.getData();
    },
    methods: {
      /**
       * 获取基础数据
       */
      getData: function() {
        let self = this;
        ServiceApi.getEditData({
              id: self.id,
              scene: self.scene
            },
            true
          )
          .then(res => {
            self.loading = false;
            self.form.scene = self.scene;
            self.form.model = res.data.model;
            self.form.category = res.data.category;
            // Object.assign(self.form, res.data);
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*提交*/
      onSubmit: function() {
        let self = this;
        self.$refs.form.validate(valid => {
          if (valid) {
            let params = formatModel(self.model, self.form.model);
            params.scene = self.scene;
            params.id = self.id;
            self.save_loading = true;
            ServiceApi.editService({
                id: self.id,
                scene: self.scene,
                params: JSON.stringify(params)
              }, true)
              .then(data => {
                self.save_loading = false;
                self.$message({
                  message: '保存成功',
                  type: 'success'
                });
                self.cancelFunc();
              })
              .catch(error => {
                self.save_loading = false;
              });
          }else{
            self.$message({
              message: '请检查必填项是否填写完整',
              type: 'error'
            });
          }
        });
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/service/service/edit.vue